import React, { useEffect } from "react";
import useProducts from "../../services/product";
import ProductList from "./product-list";
import Skeleton from 'react-loading-skeleton';
import { useSearchParams } from "react-router-dom";
import { useAppState } from "../../providers/app-state";
import {
    repair_step_heading
} from '../../lang/da'
import ConsentInfoBlock from "../../components/consent-info-block";

const RepairScreen = ({ openSidebar }) => {
    const {
        isLoading,
        data,
        error
    } = useProducts()

    if (error) {
        throw new Error("Fejl")
    }

    const { dispatchMultiple, state } = useAppState();

    const [params] = useSearchParams();


    //checks whether url contains any repair ids on load. If they exist theyre added to the selected repairs. 
    useEffect(() => {
        if (!data || state.initialProductsAdded) return;
        const productIds = params.getAll("product[]");
        if (!productIds.length) return;
        const allProducts = data.reduce((acc, cur) => {
            return [...acc, ...cur.childs.map(child => child.products).flat()]
        }, [])

        dispatchMultiple([
            {
                key: "selectedRepairs",
                value: allProducts.filter(p => productIds.includes(String(p.id)))
            },
            {
                key: "initialProductsAdded",
                value: true
            }
        ])
    }, [data, state.initialProductsAdded, dispatchMultiple, params])

    return (
        <div
            className="py-12 md:py-20 space-y-10"
        >
            <p
                className="text-3xl md:text-4xl font-light"
            >
                {
                    repair_step_heading
                }
            </p>
            {
                isLoading
                    ? (
                        <div>
                            <Skeleton
                                count={20}
                                height={60}
                                className="mt-4"
                            />
                        </div>
                    )
                    : (
                        <ProductList
                            products={data}
                            openSidebar={openSidebar}
                        />
                    )
            }
            <ConsentInfoBlock />
        </div>
    )
}

export default RepairScreen;